import { environment } from 'src/environments/environment';
import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, TemplateRef, ViewEncapsulation, Input, Output } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
// [[PrimeNg]]
import { MessageService } from 'primeng/api';
// [[Providers]]
import { CustomerUserService } from 'src/project/services/panel/client/marketplace/customer/user/user.service';
import { CollectiveMarketplaceService } from '~services/collective/client/marketplace/marketplace.service';
import { CollectiveMarketplaceCartService } from '~services/collective/client/marketplace/cart/cart.service';
import { CollectiveMarketplaceCoreVisualBannerService } from '~services/collective/client/marketplace/core/visual/banner/banner.service';
import { CustomerWishlistService } from '~services/panel/client/marketplace/customer/wishlist/wishlist.service';
import { ClientMarketplaceCoreProductService } from '~services/collective/client/marketplace/core/product/product.service';
import { ClientMarketplaceCoreProductImageService } from '~services/collective/client/marketplace/core/product/image/image.service';
import { ClientMarketplaceCoreProductRelUsageService } from '~services/collective/client/marketplace/core/product/relusage/relusage.service';
import { CustomerNoticeService } from '~services/panel/client/marketplace/customer/notice/notice.service';

import { EventEmitter } from 'stream';
// ]
// [[Interfaces/Models do Componente]]
@Component({
  selector: 'app',
  templateUrl: './component.html',
  styleUrls: ['./component.css'],
  encapsulation: ViewEncapsulation.None,
})
export class ProductViewComponent implements OnInit {
  /**
   * Base de uso em Component
   */
  public environment = environment;
  messageProcess = false;
  messageIsError: any;
  profile: any;
  marketplace: any = null;
  cart: any = null;
  banners: any = null;
  banners_fnc_cta: any = null;
  currentImage: string;

  constructor(
    /**
     * Serviços da Aplicação
     */
    private router: Router,
    private metaService: Meta,
    private titleService: Title,
    private activatedRoute: ActivatedRoute,
    /**
     * PrimeNg
     */
    private messageService: MessageService,
    /**
     * Base de uso em Component
     */
    private userService: CustomerUserService,
    private collectiveMarketplaceService: CollectiveMarketplaceService,
    private collectiveMarketplaceCartService: CollectiveMarketplaceCartService,
    private collectiveMarketplaceCoreVisualBannerService: CollectiveMarketplaceCoreVisualBannerService,
    /**
     * Services
     */
    private customerWishlistService: CustomerWishlistService,
    private clientMarketplaceCoreProductService: ClientMarketplaceCoreProductService,
    private clientMarketplaceCoreProductImageService: ClientMarketplaceCoreProductImageService,
    private clientMarketplaceCoreProductRelUsageService: ClientMarketplaceCoreProductRelUsageService,
    private customerNoticeService: CustomerNoticeService
  ) {}

  ngOnInit() {
    this.ipBuildEcommerceDependencies();
    this.clientMarketplaceCoreProductServiceShow();
    this.rightProductBoxFixedOnTop();
  }

  /**
   * build ecommerce dependencies
   */
  ipBuildEcommerceDependencies() {
    /**
     * Base
     *
     * Request da base de uso.
     */
    // PROFILE
    this.userService.getUser().subscribe((Profile: any) => {
      if (Profile != null) {
        if (JSON.parse(Profile) != null) {
          this.profile = JSON.parse(Profile);
        }
      }
    });
    // MARKETPLACE
    this.collectiveMarketplaceService.getMarketplace().subscribe((Marketplace: any) => {
      if (Marketplace != null) {
        if (JSON.parse(Marketplace) != null) {
          this.marketplace = JSON.parse(Marketplace);
          /**
           *
           * CONFIGURAÇÕES ADICIONAIS DESTE `COMPONENTE`
           *
           */
          // SEO
          this.titleService.setTitle(this.marketplace.name);
        }
      }
    });
    // CART
    this.collectiveMarketplaceCartService.getCart().subscribe((Cart: any) => {
      if (Cart != null) {
        if (JSON.parse(Cart) != null) {
          this.cart = JSON.parse(Cart);
        }
      }
    });
    // BANNERS
    this.banners_fnc_cta = function (banner: any) {
      if (banner.url != '') {
        document.location = banner.url;
      }
      return false;
    };
    this.collectiveMarketplaceCoreVisualBannerService.getBanners().subscribe((Data: any) => {
      if (Data != null) {
        if (JSON.parse(Data) != null) {
          this.banners = JSON.parse(Data);
        }
      }
    });
  }

  /**
   * after view init
   */
  ngAfterViewInit() {
    this.dataText = 'description_short';
  }

  /**
   * on destroy
   */
  ngOnDestroy() {}

  /**
   *
   */
  product: any = {};
  product_schema: object;
  shopping: any = {
    zipcode: '',
    inventory: { quantity: 1 },
  };
  clientMarketplaceCoreProductServiceShow(): void {
    this.activatedRoute.params.subscribe((params) => {
      const id = +params['id'];
      const _ = this.clientMarketplaceCoreProductService.view({ id: id });
      if (_ !== null) {
        _.subscribe(
          (response: any) => {
            this.product = response.data;
            this.currentImage = this.product.img_spotlight;
            this.clientMarketplaceCoreProductRelUsageServiceIndex();
            this.clientMarketplaceCoreProductImageServiceIndex();

            /**
             * SEO
             *
             * @param  mixed $attributes
             */
            this.titleService.setTitle(this.product.seo_body_title != '' ? this.product.seo_body_title : this.product.name);
            this.metaService.updateTag({ name: 'keywords', content: this.product.seo_body_keywords });
            this.metaService.updateTag({
              name: 'description',
              content: this.product.seo_body_description,
            });
            this.metaService.updateTag({
              name: 'og:url',
              content: 'https://' + document.domain + '/p/' + this.product.url_handle + '/id/' + this.product.id,
            });
            this.metaService.updateTag({
              name: 'og:title',
              content: this.product.seo_body_title != '' ? this.product.seo_body_title : this.product.name,
            });
            this.metaService.updateTag({
              name: 'og:type',
              content: 'product',
            });
            this.metaService.updateTag({
              name: 'og:description',
              content: this.product.seo_body_description,
            });
            this.metaService.updateTag({
              name: 'og:image',
              content: this.product.img_spotlight,
            });

            // https://schema.org/Productgit
            this.product_schema = {
              '@context': 'http://schema.org',
              '@type': 'Product',
              name: this.product.name,
              image: [this.product.img_spotlight],
              url: 'https://' + document.domain + '/p/' + this.product.url_handle + '/id/' + this.product.id,
              description: this.product.body_description_start,
              sku: this.product.code_sku,
              mpn: this.product.code_mpn,
              datePublished: '',
              brand: {
                '@type': 'Brand',
                name: this.product.salesman != null ? this.product.salesman.name : '',
              },
              // review: {
              //   "@type": "Review",
              //   reviewRating: {
              //     "@type": "Rating",
              //     ratingValue: "4",
              //     bestRating: "5",
              //   },
              //   author: {
              //     "@type": "Person",
              //     name: "Fred Benson",
              //   },
              // },
              // aggregateRating: {
              //   "@type": "AggregateRating",
              //   ratingValue: "4.4",
              //   reviewCount: "89",
              // },
              offers: {
                '@type': 'Offer',
                priceCurrency: 'BRL',
                price: this.product.price,
                url: 'https://' + document.domain + '/p/' + this.product.url_handle + '/id/' + this.product.id,
                itemCondition: 'https://schema.org/UsedCondition',
                availability: 'https://schema.org/InStock',
              },
              // FB
              title: this.product.name,
              image_link: [this.product.img_spotlight],
              id: this.product.id,
              price: this.product.price,
              availability: 'in stock',
            };

            // TODO
            // {
            //   "@context": "http://schema.org",
            //   "@type": "BreadcrumbList",
            //   "itemListElement": [{
            //     "@type": "ListItem",
            //     "position": 1,
            //     "item": {
            //       "@id": "https://example.com/arts",
            //       "name": "Arts"
            //     }
            //   },{
            //     "@type": "ListItem",
            //     "position": 2,
            //     "item": {
            //       "@id": "https://example.com/arts/books",
            //       "name": "Books"
            //     }
            //   },{
            //     "@type": "ListItem",
            //     "position": 3,
            //     "item": {
            //       "@id": "https://example.com/arts/books/poetry",
            //       "name": "Poetry"
            //     }
            //   }]
            // }
          },
          (err) => {
            if (err.error.errors) {
              for (let error in err.error.errors) {
                this.messageService.add({ severity: 'error', detail: err.error.errors[error] });
                this.messageProcess = false;
                this.messageIsError = this.clientMarketplaceCoreProductService.error.throw(error);
              }
            }
          }
        );
      }
    });
  }

  price_delivery: any;
  clientMarketplaceCoreProductServicePriceDelivery(): void {
    const _ = this.clientMarketplaceCoreProductService.price_delivery({
      id: this.product.id,
      zipcode: this.shopping.zipcode,
      inventory_quantity: this.shopping.inventory.quantity,
    });
    if (_ !== null) {
      _.subscribe(
        (response: any) => {
          this.price_delivery = response.data;
        },
        (err) => {
          if (err.error.errors) {
            for (let error in err.error.errors) {
              this.messageService.add({ severity: 'error', detail: err.error.errors[error] });
              this.messageProcess = false;
              this.messageIsError = this.clientMarketplaceCoreProductService.error.throw(error);
            }
          }
        }
      );
    }
  }

  changeImageView(image: any) {
    this.currentImage = image.url_size_576;
  }

  /**
   * Imagens do Produto
   */
  images: any;
  imagesMeta: Meta;
  image_spotlight: any;
  clientMarketplaceCoreProductImageServiceIndex() {
    var _ = this.clientMarketplaceCoreProductImageService.index({ client_marketplace_core_product_id: this.product.id });
    if (_ !== null) {
      _.subscribe(
        (response: any) => {
          this.images = response.data;
        },
        (err) => {
          if (err.error.errors) {
            for (let error in err.error.errors) {
              this.messageService.add({ severity: 'error', detail: err.error.errors[error] });
              this.messageProcess = false;
              this.messageIsError = this.clientMarketplaceCoreProductImageService.error.throw(error);
            }
          }
        }
      );
    }
  }

  /**
   * Produtos Relacionados
   */
  relProducts: any;
  clientMarketplaceCoreProductRelUsageServiceIndex() {
    var _ = this.clientMarketplaceCoreProductRelUsageService.index({
      client_marketplace_core_product_id: this.product.id,
    });
    if (_ !== null) {
      _.subscribe(
        (response: any) => {
          this.relProducts = response.data.data;
        },
        (err) => {
          if (err.error.errors) {
            for (let error in err.error.errors) {
              this.messageService.add({ severity: 'error', detail: err.error.errors[error] });
              this.messageProcess = false;
              this.messageIsError = this.clientMarketplaceCoreProductRelUsageService.error.throw(error);
            }
          }
        }
      );
    }
  }

  /**
   * Clients marketplace wishlist product service create
   */
  clientMarketplaceWishlistProductServiceCreate(id: any) {
    var _ = this.customerWishlistService.store({
      client_marketplace_core_product_id: id,
    });
    if (_ !== null) {
      _.subscribe(
        (response: any) => {
          if (response.data.hasOwnProperty('id')) {
            this.profile.customer.wishlist.push({ client_marketplace_core_product_id: id });
          } else {
            this.profile.customer.wishlist.forEach((favorite: any, index: number) => {
              if (favorite.client_marketplace_core_product_id === id) {
                this.profile.customer.wishlist.splice(index, 1);
              }
            });
          }
          this.messageService.add({ severity: 'success', detail: 'Produto adicionado a sua lista de desejos.' });
        },
        (err) => {
          if (err.error.errors) {
            for (let error in err.error.errors) {
              this.messageService.add({ severity: 'error', detail: err.error.errors[error] });
              this.messageProcess = false;
              this.messageIsError = this.customerWishlistService.error.throw(error);
            }
          }
        }
      );
    }
  }

  clientMarketplacePreferenceFavoriteServiceExists(product: any) {
    return this.profile?.customer.wishlist.find((favorite: any) => favorite.client_marketplace_core_product_id === product.id);
  }

  /**
   * Headers menu fixed on top
   */
  rightProductBoxFixedOnTop() {
    this.checkElement('sright_product_box').then((e) => {
      window.addEventListener('scroll', function () {
        var obj = document.getElementById('sright_product_box_inline');
        if (obj !== null) {
          if (!isElementVisible('sright_product_box')) {
            obj.classList.remove('none');
          } else {
            obj.classList.add('none');
          }
        }
      });
    });

    /**
     * Determines whether element visible is
     * @param el
     * @returns
     */
    var isElementVisible = function (element: string) {
      var obj = document.getElementById(element);
      if (obj !== null) {
        var positonOfTop = obj.getBoundingClientRect().top + (obj.clientHeight - 100);
        if (positonOfTop < 0) {
          return false;
        }
        return true;
      } else {
        return false;
      }
    };
  }

  checkElement = async (id: any) => {
    while (document.getElementById(id) === null) {
      await new Promise((resolve) => requestAnimationFrame(resolve));
    }
    return document.getElementById(id);
  };

  modalProductImage: boolean;

  productModalDisplayImage(data: any) {
    this.modalProductImage = true;
  }

  changeDisplayImage(data: any) {
    this.product.img_spotlight = data;
    this.modalProductImage = true;
  }

  dataText: any;

  getData(show: any) {
    this.dataText = show;
  }

  scrollToReviews() {
    var elem = document.getElementById('reviews');
    elem.scrollIntoView();
  }

  expandDetails() {
    var elem = document.getElementById('disclosure-1');
    if (elem.style.display === 'block') {
      elem.style.display = 'none';
    } else {
      elem.style.display = 'block';
    }
  }

  showDescription: boolean = false;

  actualDescription = {
    name: '',
    description: '',
  };

  showSelectedDescription(name: string, data: any) {
    this.showDescription = true;
    this.actualDescription = {
      name: name,
      description: data,
    };
  }
}
